import React, { createContext, useCallback, useContext, useEffect, useRef, useState } from 'react';
import { useAuth } from './AuthContext';
import { emptyBrain, ensureWorkspace, loadBrain } from '../services/productBrain';

const Context = createContext(null);
export function ProductBrainProvider({ children }) {
  const { user, loading: authLoading } = useAuth();
  const [data, setData] = useState(emptyBrain);
  const [errors, setErrors] = useState({});
  const [workspace, setWorkspace] = useState(null);
  const [loading, setLoading] = useState(true);
  const generation = useRef(0);
  const owner = useRef(null);
  const refresh = useCallback(async () => {
    const version = ++generation.current;
    if (!user?.id || authLoading) { setData(emptyBrain()); setWorkspace(null); setLoading(authLoading); return; }
    if (owner.current !== user.id) { setData(emptyBrain()); setErrors({}); setWorkspace(null); owner.current = user.id; }
    setLoading(true);
    const result = await loadBrain();
    try { result.workspace = await ensureWorkspace(); }
    catch (error) { result.errors.workspace = error.message; }
    if (version !== generation.current) return;
    setData(result.data); setErrors(result.errors); setWorkspace(result.workspace); setLoading(false);
  }, [user?.id, authLoading]);
  useEffect(() => {
    refresh();
    let timer;
    const changed = () => { clearTimeout(timer); timer = setTimeout(refresh, 200); };
    window.addEventListener('spcc:data-changed', changed);
    // Invalidate asynchronous loads on account change or unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return () => { generation.current++; clearTimeout(timer); window.removeEventListener('spcc:data-changed', changed); };
  }, [refresh]);
  return <Context.Provider value={{ data, errors, workspace, loading, refresh }}>{children}</Context.Provider>;
}
export const useProductBrain = () => useContext(Context);
